<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Filter Messages</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close Filter Messages"
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="filter-content d-flex m-0 pt-4 pb-2 flex-wrap" style="justify-content: space-evenly">

  <ng-container matColumnDef="type">
    <div style="padding: 5px !important;">
      <mat-form-field style="width: 170px;" class="mx-3 mt-2" appearance="outline" subscriptSizing="dynamic">
        <mat-label>Type</mat-label>
        <mat-select
          placeholder="Type"
          [(ngModel)]="filters.type"
          name="type"
          matTooltip="Filter messages by type.">
          <mat-option value="">All Types</mat-option>
          <mat-option value="email">Email</mat-option>
          <mat-option value="push notification">Push Notification</mat-option>
          <mat-option value="sms">SMS</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <ng-container matColumnDef="status">
    <div style="padding: 5px !important;">
      <mat-form-field style="width: 150px;" class="mx-3 mt-2" appearance="outline" subscriptSizing="dynamic">
        <mat-label>Status</mat-label>
        <mat-select
          placeholder="Status"
          [(ngModel)]="filters.status"
          name="status"
          matTooltip="Filter messages by status.">
          <mat-option value="">All Statuses</mat-option>
          <mat-option value="draft">Draft</mat-option>
          <mat-option value="queued">Queued</mat-option>
          <mat-option value="in progress">In Progress</mat-option>
          <mat-option value="sent">Sent</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <ng-container matColumnDef="priority">
    <div style="padding: 5px !important;">
      <mat-form-field style="width: 150px;" class="mx-3 mt-2" appearance="outline" subscriptSizing="dynamic">
        <mat-label>Priority</mat-label>
        <mat-select
          placeholder="Priority"
          [(ngModel)]="filters.priority"
          name="priority"
          matTooltip="Filter messages by priority.">
          <mat-option value="">All Priorities</mat-option>
          <mat-option value="low">Low</mat-option>
          <mat-option value="normal">Normal</mat-option>
          <mat-option value="high">High</mat-option>
          <mat-option value="critical">Critical</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <ng-container matColumnDef="date_filter_by">
    <div style="padding: 5px !important;">
      <mat-form-field style="width: 160px;" class="mx-3 mt-2" appearance="outline" subscriptSizing="dynamic">
        <mat-label>Date Filter By</mat-label>
        <mat-select
          placeholder="Date Filter By"
          [(ngModel)]="filters.date_filter"
          name="date_filter"
          matTooltip="Filter messages by the date it was created or scheduled at.">
          <mat-option value="all">All</mat-option>
          <mat-option value="created">Created Date</mat-option>
          <mat-option value="scheduled">Scheduled Date</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <ng-container matColumnDef="date_filter">
    <div style="padding: 0 1px !important;">
      <app-date-range-picker
        dateRangeTitle="Created/Scheduled Date"
        dateRangePlaceholder="Select Date Range"
        dateRangeTooltip="Filter Messages Date by date range."
        [dateRangeInput]="filters.date_range"
        (dateRangeOutput)="getOutputDateRange($event)">
      </app-date-range-picker>
    </div>
  </ng-container>

</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="d-flex flex-wrap justify-content-center my-2 py-2">

  <ng-container matColumnDef="buttons">
    <div class="p-2">
      <button
        type="button"
        mat-raised-button
        color="primary"
        (click)="onSaveAndClose()">
        <mat-icon>filter_list</mat-icon> Apply Filter
      </button>
    </div>

    <div class="p-2">
      <button
        type="button"
        mat-raised-button
        color="secondary"
        (click)="onClearAndClose()">
        <mat-icon>clear_all</mat-icon> Clear Filter
      </button>
    </div>

    <div class="p-2" *ngIf="filters.date_range.length == 2">
      <button
        type="button"
        mat-raised-button
        color="secondary"
        (click)="onClearDateRange()">
        <mat-icon>clear</mat-icon> Clear Date Range
      </button>
    </div>
  </ng-container>

</mat-dialog-actions>
